<template>
  <v-dialog v-model="dialog" max-width="650px" persistent>
    <v-card class="modal-grupos">
      
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title>Vincular Grupos</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-text class="modal-body">
        <div class="linha-vincular">
          <v-select
            class="select-grupo"
            label="Vincular Grupo"
            :items="gruposDisponiveis"
            item-text="nome"
            item-value="id"
            v-model="grupoSelecionado"
            clearable
          />
          <v-btn
            v-if="grupoSelecionado"
            fab
            small
            class="btn-add-grupo"
            :disabled="botaoAdicionarDisabled"
            @click="adicionarGrupo"
          >
            <v-icon small>add</v-icon>
          </v-btn>
        </div>
      <div class="linha-chips">
        <v-chip
          v-for="grupo in gruposSelecionados"
          :key="grupo.id"
          close
          class="ma-1"
          @input="removerGrupo(grupo.id)"
        >
          {{ grupo.nome }}
        </v-chip>
      </div>
      </v-card-text>
      <v-card-actions class="modal-footer">
        <v-spacer />
        <v-btn text color="primary" @click="cancelar">
          Cancelar
        </v-btn>
        <v-btn color="primary" dark @click="salvar">
          Salvar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: "ModalVincularGrupos",

  props: {
    value: {
      type: Boolean,
      required: true
    },
    idApolice: {
      type: [String, Number],
      default: null
    },
    idsSelecionadosInicial: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    botaoAdicionarDisabled() {
      if (!this.grupoSelecionado) return true;

      return this.gruposSelecionados.some(
        g => g.id === this.grupoSelecionado
      );
    }
  },

  data() {
    return {
      dialog: false,
      gruposDisponiveis: [],
      grupoSelecionado: null,
      gruposSelecionados: []
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val;
      }
    },

    dialog(val) {
      this.$emit("input", val);

      if (val) {
        this.inicializar();
      }
    }
  },

  methods: {
    async inicializar() {
      await this.buscarGrupos();
      this.gruposSelecionados = this.gruposDisponiveis.filter(g =>
        this.idsSelecionadosInicial.includes(g.id)
      );
    },

    async buscarGrupos() {
      await axios.get(`${process.env.URL_GRUPOMS}/v1/buscaGruposModelSimples`, {
        headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` } })
        .then((response) => {
          this.gruposDisponiveis = response.data;
        }).catch((err) => {
          console.error(err);
        });
    },

    adicionarGrupo() {
      const existe = this.gruposSelecionados.some(
        g => g.id === this.grupoSelecionado
      );

      if (existe) return;

      const grupo = this.gruposDisponiveis.find(
        g => g.id === this.grupoSelecionado
      );

      if (grupo) {
        this.gruposSelecionados.push(grupo);
      }

      this.grupoSelecionado = null;
    },

    removerGrupo(id) {
      this.gruposSelecionados = this.gruposSelecionados.filter(
        g => g.id !== id
      );
    },

    async salvar() {
      try {

        if (!this.idApolice) {
          return;
        }

        const ids = this.gruposSelecionados.map(g => g.id);

        const idApoliceNumber = parseInt(this.idApolice, 10);

        if (isNaN(idApoliceNumber)) {
          return;
        }

        const payload = {
          idApolice: idApoliceNumber,
          grupoList: ids
        };

        await axios.post(
          `${process.env.URL_APOLICEMS}/v1/salvarApoliceGrupoUsuario`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              "Content-Type": "application/json"
            }
          }
        ).catch((e) => {
            console.error(e);
        });

        this.$emit("salvo", ids);

        this.limpar();
        this.dialog = false;
      } catch (error) {
        console.error("Erro ao salvar grupos da apólice:", error);
      }
    },

    cancelar() {
      this.limpar();
      this.dialog = false;
    },

    limpar() {
      this.grupoSelecionado = null;
      this.gruposSelecionados = [];
    }
  }
};
</script>
<style scoped>
  .modal-grupos {
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }

  .modal-body {
    flex: 1;
  }

  .modal-footer {
    border-top: 1px solid #eee;
  }

  .btn-add-grupo {
    background-color: #26a69a !important;
    color: #fff !important;
    width: 36px;
    height: 36px;
    min-width: 36px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  }
  .linha-vincular {
    display: flex;
    align-items: center;
  }

  .select-grupo {
    margin-top: 12px;
    min-width: 200px;
  }

  .btn-add-grupo {
    margin-left: 12px;
    width: 36px;
    height: 36px;
    min-width: 36px;
    background-color: #26a69a !important;
    color: #fff !important;
  }

  .linha-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/frota/ModalVinculoGrupoUsuarios.vue